/**
 * Check if a value is required
 */
export const isRequired = (value?: string) => {
  return value === '' || value === null || value === undefined ? 'global.field_is_required' : undefined
}
